// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__2OM-5","crumb":"Pagination_crumb__1oGQZ","crumb_active":"Pagination_crumb_active__2x4WW"};